export const SET_ROUTE_FORM = 'ferryRouteSelection/SET_ROUTE_FORM'
export const SET_DEPARTURE_DATE = 'ferryRouteSelection/SET_DEPARTURE_DATE'
export const SET_DEPARTURE_ROUTE = 'ferryRouteSelection/SET_DEPARTURE_ROUTE'
export const SET_RETURN_DATE = 'ferryRouteSelection/SET_RETURN_DATE'
export const SET_RETURN_ROUTE = 'ferryRouteSelection/SET_RETURN_ROUTE'
export const SET_FORCES_BOOKING = 'ferryRouteSelection/SET_FORCES_BOOKING'
